export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const OPEN_NOTIFICATION = "OPEN_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
export const CLEAR_PREV_NOTIFICATION = "CLEAR_PREV_NOTIFICATION";
